import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { handleUiError, AppError } from 'src/errors';
import ErrorFallback from 'src/components/molecules/error-fallback/ErrorFallback';

const handleErrorBoundary = (error: Error, errorInfo: ErrorInfo): void => {
  if (error instanceof AppError && error.isLogged) {
    return;
  }

  handleUiError(error, errorInfo.componentStack);
};

const ErrorBoundaryProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleErrorBoundary}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryProvider;
